var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80294 14.8635L14.8509 9.69456M11.6009 5.59949L6.13167 11.1805C5.88796 11.4243 5.75104 11.7549 5.75104 12.0996C5.75104 12.4443 5.88796 12.7749 6.13167 13.0187C6.37546 13.2624 6.70607 13.3993 7.05079 13.3993C7.39551 13.3993 7.72611 13.2624 7.9699 13.0187L13.4391 7.43772C13.9265 6.95014 14.2004 6.28893 14.2004 5.59949C14.2004 4.91005 13.9265 4.24884 13.4391 3.76126C12.9515 3.27382 12.2903 3 11.6009 3C10.9114 3 10.2502 3.27382 9.76264 3.76126L4.29279 9.3416C3.56132 10.0731 3.15039 11.0652 3.15039 12.0996C3.15039 13.1341 3.56132 14.1261 4.29279 14.8576C5.02426 15.5891 6.01634 16 7.05079 16C8.08524 16 9.07732 15.5891 9.80879 14.8576",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.005d0e844300d47732a26a67a5028a2f.svg";
export { ForwardRef as ReactComponent };